export default __webpack_public_path__ + "static/N0284-4547e229807a427dedcacd6573d56a3e.png";